require('angular')
LocationTrackingService = require('./location-tracking-service')
LocationTrackingInterceptor = require('./location-tracking-interceptor')

angular.module 'gnp-location-tracking', []
  .factory 'LocationTrackingService', LocationTrackingService
  .run LocationTrackingInterceptor




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/location-tracking/location-tracking-module.coffee